@if (categoryDtos) {
  <div class="page-root">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ "form.label.location_filter" | transloco }}</mat-card-title>
      </mat-card-header>

      <mat-card-content class="column-stretch">
        <mat-form-field>
          <mat-label>{{ "form.label.location_filter" | transloco }}</mat-label>
          <mat-select [formControl]="locationFilterFormControl" (valueChange)="changeFilter($event)">
            @for (locationFilter of locationFilters; track $index) {
              <mat-option [value]="locationFilter">{{ locationName(locationFilter) }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header class="row-space-between">
        <mat-card-title>{{ "category.title" | transloco }}</mat-card-title>

        <div class="card-action" (click)="add()">
          <mat-icon> add_circle</mat-icon>
          <mat-label>{{ "category.add_category" | transloco }}</mat-label>
        </div>
      </mat-card-header>

      <mat-card-content>
        <mat-table [dataSource]="filteredCategories" cdkDropList (cdkDropListDropped)="reorder($event)"
                   class="width-none" cdkDropListData="filteredCategories" #table>
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.name" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let category" class="row-gap-small-center">
              <mat-icon class="no-shrink">reorder</mat-icon>
              <div>{{ category.name | localizedText }}</div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="location">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.location" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let category">{{ showLocationPreview(category.locationId) }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="duration">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.appointment_duration" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let category">{{ category.appointmentDurationMinutes }} {{ "time.minutes" | transloco }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="slot">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.appointment_slot" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let category">{{ category.slotDurationMinutes }} {{ "time.minutes" | transloco }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="interval">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.start_time_interval" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let category">
              @if (!category.startTimeIntervalMinutes) {
                <div>{{ "category.location_setting" | transloco }}</div>
              } @else {
                <div>{{ category.startTimeIntervalMinutes }} {{ "time.minutes" | transloco }}</div>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="url">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.direct_url" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let category">
              @if (category.locationId > 0) {
                <button mat-icon-button (click)="copyUrl(category.locationId, category.categoryId)">
                  <mat-icon>link</mat-icon>
                </button>
              } @else {
                <button mat-icon-button [matMenuTriggerFor]="locationMenu">
                  <mat-icon>link</mat-icon>
                </button>
                <mat-menu #locationMenu="matMenu">
                  @for (location of locationSummaryDtos; track $index) {
                    <button mat-menu-item (click)="copyUrl(location.locationId, category.categoryId)">{{ locationName(location.locationId) }}</button>
                  }
                </mat-menu>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let category" class="row-end">
              <button mat-icon-button (click)="edit(category)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="delete(category)">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef='["name", "location", "duration", "slot", "interval", "url", "actions"]'></mat-header-row>
          <mat-row
            *matRowDef='let category; columns: ["name", "location", "duration", "slot", "interval", "url", "actions"]'
            cdkDrag [cdkDragData]="category"></mat-row>
        </mat-table>
      </mat-card-content>
    </mat-card>
  </div>
}
